import React from "react";

/**
 * @component RadioButtonIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <RadioButtonIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RadioButtonIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RadioButtonIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <circle stroke="#5D2BFF" cx={8} cy={8} r={7.5} />
        <circle cx={8} cy={8} r={5} />
      </g>
    </svg>
  )
);
RadioButtonIcon.displayName = "RadioButtonIcon";
export default RadioButtonIcon;
